import React from 'react';
import './AboutUs.css'

const AboutUs = () => {
    return (
        <div className="about_us">
            <h2 className="choose">Why Choose Us ?</h2>
            <h5>​1. Quality and Services</h5>

            <p>Here, our quality and service go hand-in-hand. We do our utmost to ensure that these two hallmarks are met at every step of your journey. To help achieve the core values, we closely monitor client satisfaction and are consistently seeking new ways to exceed our clients’ expectations.
            </p>
            <h5>2. Quality and Value</h5>
            <p>We take great care to ensure that our products are the best value for money in the business, and we know that outstanding value means ensuring all things are right, not just the price</p>
            <h5>3. 24-Hours Support</h5>
            <p>We are available to you 24 hours a day, 7 days a week to provide easy assistance, an open mind and a caring ear in case of any emergency help needed.</p>
            <h5>4. Trust</h5>
            <p>We are license travel agency registered with Ministry of Tourism and Culture Malaysia. We have obligation to abide by rules, face scrutiny and be accountable for everything we do and are held up to a high level of standards and practices. In addition all travel deposits are held in a trust and protected for your security.
            </p>


        </div>
    );
};

export default AboutUs;